import { Box, Text } from '@rbilabs/universal-components';

import { LoyaltyNoRewardPoints } from 'pages/loyalty/loyalty-no-reward-points';

import LoyaltyClaimPointsLink from '../loyalty-claim-points/loyalty-claim-points-link';

const Header = Text.withConfig({
  fontWeight: Styles.fontWeight.heavy,
});

export const RightHeader = Header.withConfig({
  flex: 1,
  textAlign: 'right',
});

export const LeftHeader = Header.withConfig({
  flexGrow: 1,
  textAlign: 'left',
});

export const CenterHeader = Header.withConfig({
  paddingRight: '$4',
  flexGrow: 1,
  textAlign: 'center',
});

export const TransactionDateAndTime = Box.withConfig({
  alignItems: 'flex-start',
});

export const TransactionDate = Text.withConfig({
  fontSize: 'md',
});

export const TransactionTime = Text.withConfig({
  fontSize: 'xs',
});

export const StyledLoyaltyClaimPointsLink = LoyaltyClaimPointsLink.withConfig({
  marginY: '$4',
  marginX: 'auto',
  paddingY: '$3',
  paddingX: '$5',
});

export const StyledLoyaltyNoRewardPoints = LoyaltyNoRewardPoints;
